import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, Pagination } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const rooms = () => {
	// previewPin()
	// preview()
}

const previewPin = () => {

	let el = document.querySelector('[data-animation="rooms-pin"]')

	if (!el) return false

	console.log(el)

	let tl = gsap.timeline({

		scrollTrigger: {
			trigger: '.container',
			pin: true,
			start: 'top top',
			end: '+=500',
			scrub: 1,
			snap: {
				trigger: el,
				start: 'center center',
				end: '+=1000',
				pin: true,
				markers: true,
			}
		}
	});


	tl.addLabel('start')
		.from('.box p', { scale: 0.3, rotation: 45, autoAlpha: 0 })
		.addLabel('color')
		.from('.box', { backgroundColor: '#28a92b' })
		.addLabel('spin')
		.to('.box', { rotation: 360 })
		.addLabel('end');




	gsap.fromTo(el, {

	}, {

		scrollTrigger: {
		}
	})
}



















export default () => { }